const startOfDay = (date) => {
  const next = new Date(date)
  next.setHours(0, 0, 0, 0)
  return next
}

const addMinutes = (date, minutes) => {
  return new Date(date.getTime() + minutes * 60 * 1000)
}

const formatISO = (date) => date.toISOString()

const today = startOfDay(new Date())

export const mockLeagueNewEvents = [
  {
    "leagueId": 760252,
    "leagueName": "England EFL Cup",
    "rapidLeagueId": 10042428,
    "eventDetails": [
      {
        "upcommingEventId": 540781,
        "rapidEventId": 181917775,
        "homeTeam": "Grimsby",
        "homeTeamMyan": "ဂရင်းစ်ဘိုင်",
        "homeTeamId": 1042151,
        "awayTeamId": 1002447,
        "awayTeam": "Brentford",
        "awayTeamMyan": "ဘရန့်ဖို့",
        "eventDate": "2025-10-29T00:00:00",
        "eventTime": "2025-10-29T02:15:00",
        "isMix": false,
        "isSingle": false,
        "isFivePercent": false
      },
      {
        "upcommingEventId": 540782,
        "rapidEventId": 181917797,
        "homeTeam": "Wrexham",
        "homeTeamMyan": "\tဝရက်ဟမ်",
        "homeTeamId": 1058648,
        "awayTeamId": 1042179,
        "awayTeam": "Cardiff",
        "awayTeamMyan": "ကာဒစ်",
        "eventDate": "2025-10-29T00:00:00",
        "eventTime": "2025-10-29T02:30:00",
        "isMix": false,
        "isSingle": false,
        "isFivePercent": false
      },
      {
        "upcommingEventId": 540783,
        "rapidEventId": 181917804,
        "homeTeam": "Wycombe",
        "homeTeamMyan": "ဝိုင်ကွမ်ဘီ",
        "homeTeamId": 1042176,
        "awayTeamId": 1046585,
        "awayTeam": "Fulham",
        "awayTeamMyan": "ဖူဟမ်",
        "eventDate": "2025-10-29T00:00:00",
        "eventTime": "2025-10-29T02:15:00",
        "isMix": false,
        "isSingle": false,
        "isFivePercent": false
      }
    ]
  },
  {
    "leagueId": 80058,
    "leagueName": "Greece Cup",
    "rapidLeagueId": 10042376,
    "eventDetails": [
      {
        "upcommingEventId": 543291,
        "rapidEventId": 182557718,
        "homeTeam": "AE Kifisias",
        "homeTeamMyan": "AE ကီဖီဆီးရပ်စ်",
        "homeTeamId": 995391,
        "awayTeamId": 1086119,
        "awayTeam": "Athens Kallithea",
        "awayTeamMyan": "အေသင် ကလီသီရာ",
        "eventDate": "2025-10-29T00:00:00",
        "eventTime": "2025-10-29T00:30:00",
        "isMix": false,
        "isSingle": false,
        "isFivePercent": false
      },
      {
        "upcommingEventId": 543293,
        "rapidEventId": 182557723,
        "homeTeam": "OFI Crete",
        "homeTeamMyan": "OFI ခရီတီ",
        "homeTeamId": 80754,
        "awayTeamId": 1049795,
        "awayTeam": "Iraklis 1908 FC",
        "awayTeamMyan": "အီရာလစ် 1908 FC",
        "eventDate": "2025-10-28T00:00:00",
        "eventTime": "2025-10-28T20:30:00",
        "isMix": false,
        "isSingle": false,
        "isFivePercent": false
      },
      {
        "upcommingEventId": 543295,
        "rapidEventId": 182557730,
        "homeTeam": "Panetolikos",
        "homeTeamMyan": "ပါနီတိုလီကော့",
        "homeTeamId": 90890,
        "awayTeamId": 1101091,
        "awayTeam": "Hellas Syrou",
        "awayTeamMyan": "ဟယ်လက်ဆာရူး",
        "eventDate": "2025-10-28T00:00:00",
        "eventTime": "2025-10-28T22:30:00",
        "isMix": false,
        "isSingle": false,
        "isFivePercent": false
      }
    ]
  },
  {
    "leagueId": 60019,
    "leagueName": "Italy Serie A",
    "rapidLeagueId": 10041315,
    "eventDetails": [
      {
        "upcommingEventId": 548316,
        "rapidEventId": 182658309,
        "homeTeam": "Lecce",
        "homeTeamMyan": "လက် ချီ",
        "homeTeamId": 1042279,
        "awayTeamId": 60195,
        "awayTeam": "Napoli",
        "awayTeamMyan": "နာပိုလီ",
        "eventDate": "2025-10-29T00:00:00",
        "eventTime": "2025-10-29T00:00:00",
        "isMix": false,
        "isSingle": false,
        "isFivePercent": false
      },
      {
        "upcommingEventId": 548318,
        "rapidEventId": 182658311,
        "homeTeam": "Atalanta",
        "homeTeamMyan": "အတ္တလန္တာ",
        "homeTeamId": 90808,
        "awayTeamId": 60610,
        "awayTeam": "AC Milan",
        "awayTeamMyan": "အေစီမီလန်",
        "eventDate": "2025-10-29T00:00:00",
        "eventTime": "2025-10-29T02:15:00",
        "isMix": false,
        "isSingle": false,
        "isFivePercent": false
      }
    ]
  }
]

export const mockLeagueEvents = [
  {
    id: 'EVT-1001',
    leagueId: 'L001',
    leagueName: 'Premier League',
    region: 'England',
    homeTeam: 'Manchester City',
    awayTeam: 'Arsenal',
    eventTime: formatISO(addMinutes(today, 120)),
    market: '1X2',
    spotlight: true,
  },
   {
    id: 'EVT-10011',
    leagueId: 'L001',
    leagueName: 'Premier League',
    region: 'England',
    homeTeam: 'Manchester City',
    awayTeam: 'Arsenal',
    eventTime: formatISO(addMinutes(today, 120)),
    market: '1X2',
    spotlight: true,
  },
   {
    id: 'EVT-10012',
    leagueId: 'L001',
    leagueName: 'Premier League',
    region: 'England',
    homeTeam: 'Manchester City',
    awayTeam: 'Arsenal',
    eventTime: formatISO(addMinutes(today, 120)),
    market: '1X2',
    spotlight: true,
  },
   {
    id: 'EVT-10013',
    leagueId: 'L001',
    leagueName: 'Premier League',
    region: 'England',
    homeTeam: 'Manchester City',
    awayTeam: 'Arsenal',
    eventTime: formatISO(addMinutes(today, 120)),
    market: '1X2',
    spotlight: true,
  },
  {
    id: 'EVT-1002',
    leagueId: 'L002',
    leagueName: 'La Liga',
    region: 'Spain',
    homeTeam: 'Real Madrid',
    awayTeam: 'Barcelona',
    eventTime: formatISO(addMinutes(today, 180)),
    market: 'Asian Handicap',
    spotlight: true,
  },
  {
    id: 'EVT-1003',
    leagueId: 'L003',
    leagueName: 'Serie A',
    region: 'Italy',
    homeTeam: 'Inter Milan',
    awayTeam: 'Juventus',
    eventTime: formatISO(addMinutes(today, 300)),
    market: 'Over/Under',
  },
  {
    id: 'EVT-1004',
    leagueId: 'L004',
    leagueName: 'Bundesliga',
    region: 'Germany',
    homeTeam: 'Bayern Munich',
    awayTeam: 'Borussia Dortmund',
    eventTime: formatISO(addMinutes(today, 420)),
    market: 'Both Teams To Score',
  },
  {
    id: 'EVT-1005',
    leagueId: 'L005',
    leagueName: 'Ligue 1',
    region: 'France',
    homeTeam: 'PSG',
    awayTeam: 'Lyon',
    eventTime: formatISO(addMinutes(today, 90)),
    market: '1X2',
  },
  {
    id: 'EVT-1006',
    leagueId: 'L001',
    leagueName: 'Premier League',
    region: 'England',
    homeTeam: 'Chelsea',
    awayTeam: 'Tottenham',
    eventTime: formatISO(addMinutes(today, 510)),
    market: 'Asian Handicap',
  },
  {
    id: 'EVT-1007',
    leagueId: 'L002',
    leagueName: 'La Liga',
    region: 'Spain',
    homeTeam: 'Atletico Madrid',
    awayTeam: 'Sevilla',
    eventTime: formatISO(addMinutes(today, 240)),
    market: 'Over/Under',
  },
  {
    id: 'EVT-1008',
    leagueId: 'L006',
    leagueName: 'Primeira Liga',
    region: 'Portugal',
    homeTeam: 'Porto',
    awayTeam: 'Benfica',
    eventTime: formatISO(addMinutes(today, 60)),
    market: '1X2',
  },
  {
    id: 'EVT-1009',
    leagueId: 'L007',
    leagueName: 'Eredivisie',
    region: 'Netherlands',
    homeTeam: 'Ajax',
    awayTeam: 'PSV',
    eventTime: formatISO(addMinutes(today, 360)),
    market: 'Both Teams To Score',
  },
  {
    id: 'EVT-1010',
    leagueId: 'L008',
    leagueName: 'MLS',
    region: 'USA',
    homeTeam: 'LA Galaxy',
    awayTeam: 'Seattle Sounders',
    eventTime: formatISO(addMinutes(today, 600)),
    market: '1X2',
  },
]

export const leagueOptions = mockLeagueEvents.reduce((acc, event) => {
  if (!acc.some((league) => league.id === event.leagueId)) {
    acc.push({
      id: event.leagueId,
      label: `${event.leagueName} - ${event.region}`,
      description: `League ID: ${event.leagueId}`,
    })
  }
  return acc
}, [])

export const sortingOptions = [
  { id: 'time-asc', label: 'Event A to Z' },
  { id: 'time-desc', label: 'Event Z to A' },
  { id: 'league-id', label: 'Event ID' },
]

export const timeWindowOptions = [
  { id: 'all', label: 'All upcoming' },
  { id: '60', label: 'Next 60m' },
  { id: '180', label: 'Next 3h' },
  { id: '360', label: 'Next 6h' },
  { id: '720', label: 'Next 12h' },
]

export const marketOptions = [
  { id: 'all', label: 'All markets' },
  { id: '1X2', label: '1X2' },
  { id: 'Asian Handicap', label: 'Asian Handicap' },
  { id: 'Over/Under', label: 'Over / Under' },
  { id: 'Both Teams To Score', label: 'Both teams to score' },
]

export const defaultEventFilters = {
  leagueId: '',
  search: '',
  timeWindow: timeWindowOptions[0],
  market: marketOptions[0],
  sortOption: sortingOptions[0],
}
